<template>
<main id="maincontent">
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <Error ref="error" />
        <div class="card-body" @keyup.enter="submitCreateUser">
            <PageHeader :title="screenData.text.cardTitle" variant="small" class="mb-4" />
            <Username ref="username" :username-label="screenData.text" :create-user="true" 
                      :requirements-label="screenData.text.usernameRequirements" @set-username="setUsername"></Username>
            <SSN ref="ssn" :labels="screenData.text" name="taxId" is-disabled="true"></SSN>
            <AccountNumber name="accountNumber" :labels="screenData.text" :required="accountRequired" @set-account-number="setAccountNumber"></AccountNumber>
            <DateOfBirth :labels="screenData.text" v-model:required="dateOfBirthRequired" v-model:value="dateOfBirth" @set-date-of-birth="setDateOfBirth"></DateOfBirth>
            <NewPassword :password-label="screenData.text" :user-id="userId" :verify-password-label="screenData.text.verifyPassword"
                         :requirements-label="screenData.text.passwordRequirements" @set-new-password="setNewUserPassword"></NewPassword>
            <ActionList :actions="screenData.actions" @create-new-user="createUser" @cancel-create-new-user="cancel"></ActionList>
        </div>
    </div>
</main>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import Username from '../entities/Username.vue';
    import SSN from '../entities/SSN.vue';
    import AccountNumber from '../entities/AccountNumber.vue';
    import DateOfBirth from '../entities/DateOfBirth.vue';
    import NewPassword from '../entities/NewPassword.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "NewUser",

        components: {
            Error,
            Username,
            SSN,
            AccountNumber,
            DateOfBirth,
            NewPassword,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object,
            profileCallerId: String
        },

        data: function() {
            return {
                active: false,                
                tinType: "",
                taxId: "",
                accountRequired: "",
                accountNumber: "",
                dateOfBirthRequired: "",
                dateOfBirth: "",
                createAPI: "",
                stateToken: "",
                userId: "",
                password: "",
                devicePrint: encode_deviceprint(),
                isValid: false
            }
        },

        methods: {
            show: function(data) {
                this.tinType = data.tinType;
                this.taxId = data.taxId;
                this.accountRequired = data.accountRequired;
                this.dateOfBirthRequired = data.dateOfBirthRequired;
                this.createAPI = data.createAPI;
                this.stateToken = data.stateToken;
                this.active = true;
                nextTick(function() {
                    this.$emitter.emit('disable','create-new-user');
                }.bind(this));
            },

            hide: function() {
                this.active = false;
            },

            submitCreateUser: function() {
                if (this.isValid) {
                    this.createUser();
                }
            },

            createUser: function() {
                this.$emitter.emit('start-loading','create-new-user');
                this.$refs["error"].clear();
                var data = {
                    cwUserIdMaint: {
                        taxId: this.taxId,
                        taxIdFormatCode: this.tinType,
                        newUserId: this.userId,
                        newPassword: this.password,
                    },
                    devicePrint: this.devicePrint,
                    stateToken: this.stateToken,
                    profileCallerId: this.profileCallerId
                };

                if (this.accountRequired) {
                    data.cwUserIdMaint["accountNumber"] = this.accountNumber;
                }

                if(this.dateOfBirthRequired) {
                    data.cwUserIdMaint["customerBirthDate"] = this.dateOfBirth;
                }

                this.$axios.post(this.createAPI, data).then(function(response) {
                    if (response.data.success) {
                        var data = {
                            flow: this.screenData.text.flow,
                            stateToken: response.data.data.stateToken
                        };
                        if (response.data.data.status === "MFA_ENROLL") {
                            this.$root.username = this.$refs["username"].getValue();
                            data.addAPI = response.data.data._links.next.href;
                            this.$emitter.emit('navigate', { componentName: 'mfaEnroll', routeData: data});
                        }
                        else if (response.data.data.status === "SUCCESS") {
                            this.$root.username = this.$refs["username"].getValue();
                            this.start(response.data.data._links);
                        }
                        else {
                            this.$root.username = this.$refs["username"].getValue();
                            data.methods = response.data.data._embedded.factors;
                            this.$emitter.emit('navigate', { componentName: 'mfaSelect', routeData: data});
                        }
                        this.$emitter.emit('stop-loading','create-new-user');
                    }
                }.bind(this)).catch(function(error) {
                    if (typeof error.response.data == 'string' || error.response.data.messages.length > 0) {
                        var err = typeof error.response.data == 'string' ? {
                                errorCode: error.response.status,
                                errorMessage: error.message
                            } : error.response.data.messages[0];   
                        this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                        this.isValid = false;
                    }
                    this.$emitter.emit('stop-loading','create-new-user');
                    
                    this.$emitter.emit('reprofileThreatMatrics');

                }.bind(this));
            },

            cancel: function() {
                this.$emitter.emit('start-loading','cancel-create-new-user');
                window.location.href = window.location.href;
            },

            setUsername: function(val) {
                this.userId = val;
            },

            setAccountNumber: function(val) {
                this.accountNumber = val;
            },

            setDateOfBirth: function(val) {
                this.dateOfBirth = val;
            },

            setNewUserPassword: function(val) {
                this.password = val;
            }
        },

        watch: {
            taxId: function(val, oldVal) {
                if(val !== oldVal)
                    nextTick(() => this.$refs.ssn.setValue(val));
            },

            password: function(val) {
                this.isValid = val !== "" && this.userId !== "" && (this.accountNumber !== "" || !this.accountRequired) && (this.dateOfBirth !== "" || !this.dateOfBirthRequired);
            },

            userId: function(val) {
                this.isValid = val !== "" && this.password !== "" && (this.accountNumber !== "" || !this.accountRequired) && (this.dateOfBirth !== "" || !this.dateOfBirthRequired);
            },

            accountNumber: function(val) {
                this.isValid = val !== "" && this.password !== "" && this.userId !== "" && (this.dateOfBirth !== "" || !this.dateOfBirthRequired);
            },

            dateOfBirth: function(val) {
                this.isValid = val !== "" && this.password !== "" && this.userId !== "" && (this.accountNumber !== "" || !this.accountRequired);
            },

            isValid: function(val) {
                if (val) {
                    this.$emitter.emit('enable','create-new-user');
                }
                else {
                    this.$emitter.emit('disable','create-new-user');
                }
            }
        },

        computed: {
            clientProfile: function() {
                return this.getClientProfile();
            }
        },

        inject: [
            'getClientProfile'
        ]
    }
</script>